export class Constants {
  static readonly BRAND_SFLY: string = 'sfly';
  static readonly BRAND_SNF: string = 'snf';
  static readonly SOURCE_KRAKEN: string = 'kraken';
  static readonly SOURCE_BULK_API: string = 'bulkApi';
  static readonly SNF_ROTATION_0: string = 'rf=cw/rf=cw/rf=cw/rf=cw';
  static readonly SNF_ROTATION_KEY: string = 'rf';
  static readonly SNF_ROTATION_KEY_CW_CW_CW_CW: string = 'cw/cw/cw/cw';
  static readonly SNF_ROTATION_KEY_CW: string = 'cw';
  static readonly SNF_ROTATION_KEY_UD: string = 'ud';
  static readonly SNF_ROTATION_KEY_CW_CW: string = 'cw/cw';
  static readonly SNF_ROTATION_KEY_CCW: string = 'ccw';
  static readonly SNF_ROTATION_KEY_CCW_CCW: string = 'cw/cw/cw';
  static readonly SNF_ROTATION_90: string = 'rf=cw';
  static readonly SNF_ROTATION_180: string = 'rf=ud';
  static readonly SNF_ROTATION_180_1: string = 'rf=cw/rf=cw';
  static readonly SNF_ROTATION_270: string = 'rf=ccw';
  static readonly SNF_ROTATION_270_1: string = 'rf=cw/rf=cw/rf=cw';
  static readonly SNF_EFFECT_NONE: string = 'ef=no';
  static readonly SNF_EFFECT_AUTO: string = 'ef=au';
  static readonly SNF_EFFECT_VINTAGE: string = 'ef=vt';
  static readonly SNF_EFFECT_AFS_SEPIA: string = 'ef=sp';
  static readonly SNF_EFFECT_SUNSHINE: string = 'ef=su';
  static readonly SNF_EFFECT_BLACKANDWHITE: string = 'ef=bw';
  static readonly SNF_EFFECT_VIBRANT: string = 'ef=vb';
  static readonly SNF_EFFECT_SATURATE: string = 'ef=sa:';
  static readonly SNF_EFFECT_SOFTEN: string = 'ef=so:';
  static readonly SNF_EFFECT_SEPIA: string = 'ef=sp:';
  static readonly SNF_CROP: string = 'ca=';
  static readonly SNF_ENHANCE: string = 'en=au';
  static readonly SFLY_ROTATION_0: string = 'rotation=0';
  static readonly SFLY_ROTATION_90: string = 'rotation=90';
  static readonly SFLY_ROTATION_180: string = 'rotation=180';
  static readonly SFLY_ROTATION_180_1: string = 'rotation=180';
  static readonly SFLY_ROTATION_270: string = 'rotation=270';
  static readonly SFLY_EFFECT_NONE: string = 'effect=NONE';
  static readonly SFLY_EFFECT_AUTO: string = 'effect=AUTO';
  static readonly SFLY_EFFECT_VINTAGE: string = 'effect=AFS-Vintage';
  static readonly SFLY_EFFECT_AFS_VINTAGE: string = 'effect=AFS_VINTAGE';
  static readonly SFLY_EFFECT_AFS_SEPIA: string = 'effect=AFS-Sepia';
  static readonly SFLY_EFFECT_AFS_SEPIA_US: string = 'effect=AFS_SEPIA';
  static readonly SFLY_EFFECT_SUNSHINE: string = 'effect=AFS-Sunshine';
  static readonly SFLY_EFFECT_AFS_SUNSHINE: string = 'effect=AFS_SUNSHINE';
  static readonly SFLY_EFFECT_BLACKANDWHITE: string = 'effect=AFS-BlackWhite';
  static readonly SFLY_EFFECT_MONOCHROME: string = 'effect=MONOCHROME';
  static readonly SFLY_EFFECT_VIBRANT: string = 'effect=AFS-Vibrant';
  static readonly SFLY_EFFECT_AFS_VIBRANT: string = 'effect=AFS_VIBRANT';
  static readonly SFLY_EFFECT_SATURATE: string = 'effect=SATURATE:';
  static readonly SFLY_EFFECT_SOFTEN: string = 'effect=SOFTEN:';
  static readonly SFLY_EFFECT_SEPIA: string = 'effect=SEPIA:';
  static readonly SFLY_CROP_LL: string = 'cropll=';
  static readonly SFLY_CROP_UR: string = 'cropur=';
  static readonly SFLY_RED_EYE: string = 'redeye';
  static readonly SFLY_ENHANCE: string = 'enhance=AUTO';
}
